import React, { useEffect, useState, useContext } from 'react';
import SearchContext from '../../state/context';

export const QuerySummary = props => {
  const { controller } = props;
  const [state, setState] = useState(controller.state);

  const { querySummaryObject } = useContext(SearchContext);

  const {
    querySummaryShowingText,
    querySummaryOfText,
    querySummaryResultsText
  } = querySummaryObject;

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  const { hasResults, firstResult, lastResult, total } = state;

  if (!hasResults || total === 0) {
    return null;
  }

  const summary =
    total > 1
      ? [
          `${querySummaryShowingText} <strong>${firstResult}</strong> - <strong>${lastResult}</strong> ${querySummaryOfText} <strong>${total}</strong> ${querySummaryResultsText}`
        ]
      : [
          `Showing <strong>1</strong> ${querySummaryResultsText.substring(
            0,
            querySummaryResultsText.length - 1
          )}`
        ];

  return <p dangerouslySetInnerHTML={{ __html: summary.join(' ') }} />;
};

export default QuerySummary;
